var portalContainer = 'fx_2d2fb1e5_1a7h8q0';

export { portalContainer };
//# sourceMappingURL=portalContainer.vanilla.mjs.map
